import { changeVariants } from './change-variants';
import { activateZoom } from './activate-zoom';
import { reIndexSlide } from './slick-reindex';
import { addToCart, updateCartGift, updateCart, ajaxCart } from './ajax-cart';
import { productSelectGlobal } from './product-select-global';

const $doc = $(document);
const $win = $(window);
const $selectGlobal = $('.js-select-global');

// Sliders Product
const $sliderProduct = $('.js-slider-product');
const $sliderThumbs = $('.js-slider-thumbs');

$sliderProduct.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: true,
  fade: true,
  draggable: false,
  asNavFor: $sliderThumbs
});

$sliderThumbs.slick({
  asNavFor: $sliderProduct,
  focusOnSelect: true,
  infinite: true,
  autoplay: false,
  speed: 300,
  arrows: true,
  dots: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  draggable: false,
  touchMove: false,
  swipe: false,
  vertical: true
});

$sliderProduct
  .on('reInit', function(slick){
    if ($sliderProduct.hasClass('js-slider-zoom')) {
      activateZoom($sliderProduct);
    };
  })
  .on('afterChange', function(slick, currentSlide){
    if ($sliderProduct.hasClass('js-slider-zoom')) {
      activateZoom($sliderProduct);
    };
  })

// Change Variants - Radio
$doc.on('change', '.js-radio-color input', function() {
  const $this = $(this);
  const radioVal = $this.val();
  const radioTitle = $this.data('value');
  const optionIndex = $this.data('option');
  const $product = $this.closest('.js-product');
  const $sliderProductFilter = $product.find('.js-slider-product');
  const $sliderThumbsFilter = $product.find('.js-slider-thumbs');
  const radioIdx = $this.data('index');
  const sliderFilter = $this.data('filter-slider');

  changeVariants($this);

  if ($product.find('.js-product-inline-image figure').length) {
    $product
      .find('.js-product-inline-image figure')
      .eq(radioIdx)
      .addClass('expanded')
      .siblings()
      .removeClass('expanded');
  };

  if ($sliderProductFilter.length && sliderFilter != false) {
    $sliderProductFilter.slick('slickUnfilter');
    $sliderProductFilter.slick('slickFilter', function() {
      if ($(this).find('.section__image').hasClass(`section__image--${radioVal}`) || $(this).find('.section__image').hasClass(`section__image--video`)) {
        return $(this);
      }
    });
    reIndexSlide($sliderProductFilter);
  };

  if ($sliderThumbsFilter.length && sliderFilter != false) {
    $sliderThumbsFilter.slick('slickUnfilter');
    $sliderThumbsFilter.slick('slickFilter', function() {
      if ($(this).find('.thumb').hasClass(`thumb--${radioVal}`) || $(this).find('.thumb').hasClass(`thumb--video`)) {
        return $(this);
      }
    });

    $sliderThumbsFilter.slick('setPosition');
    reIndexSlide($sliderThumbsFilter);
  };
});

// On Load Functionality - Global Select
productSelectGlobal($selectGlobal);

// Change Variants - Select
$doc.on('change', '.js-select-product select', function() {
  const $this = $(this);

  changeVariants($this);
});

// Change Radio Color On Load
if ($('.js-radio-color input:checked').length) {
  $('.js-radio-color input:checked').trigger('change');
};

// Add To Cart - AJAX
$doc.on('click', '.js-form-product .js-product-btn', function(e) {
  e.preventDefault();
  const $form = $(this).closest('form');

  addToCart($form, true);
});



// WEBPACK FOOTER //
// ../assets/js/product.js